<template>
  <div>
    <v-container fluid class="px-6 py-6">
      <!-- Permission Check: Nur für Admins und Manager (KEIN POS) -->
      <permission-denied 
        v-if="!hasAnalyticsPermission" 
        message="Du benötigst Manager- oder Administrator-Rechte, um auf das Dashboard zuzugreifen."
      />

      <!-- Dashboard Content nur für berechtigte User -->
      <div v-else>
      <!-- Year Selection - Sticky under navbar -->
      <year-selector :sticky="true" />
      <!-- <v-row class="mb-12">
        <v-col md="12">
          <sales-country></sales-country>
        </v-col>
      </v-row> -->
      <v-col cols="12" class="mb-6">
        <calendar-widget></calendar-widget>
      </v-col>
      <v-row class="mb-6 mt-15">
        <v-col lg="6" class="pt-0 mb-lg-0 mb-10">
          <card-daily-sales></card-daily-sales>
        </v-col>
        <v-col lg="6" class="pt-0 mb-lg-0 mb-10">
          <card-website-views></card-website-views>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-row>
            <v-col md="6" cols="12">
              <v-card class="mb-6 card-shadow border-radius-xl py-4">
                <v-row no-gutters class="px-4">
                  <v-col sm="4">
                    <v-avatar
                      color="bg-gradient-default border-radius-xl mt-n8"
                      class="shadow-dark"
                      height="64"
                      width="64"
                    >
                      <v-icon class="material-icons-round text-white" size="24"
                        >weekend</v-icon
                      >
                    </v-avatar>
                  </v-col>
                  <v-col sm="8" class="text-end">
                    <p
                      class="text-sm mb-0 text-capitalize text-body font-weight-light"
                    >
                      Buchungen {{ selectedYear || currentYear }}
                    </p>
                    <h4 class="text-h4 text-typo font-weight-bolder mb-0">
                      <span v-if="updatingEvents">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="2"
                          color="primary"
                        ></v-progress-circular>
                      </span>
                      <span v-else>{{ eventEntries }}</span>
                    </h4>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col md="6" cols="12">
              <v-card class="mb-6 card-shadow border-radius-xl py-4">
                <v-row no-gutters class="px-4">
                  <v-col sm="4">
                    <v-avatar
                      color="bg-gradient-primary border-radius-xl mt-n8"
                      class="shadow-primary"
                      height="64"
                      width="64"
                    >
                      <v-icon class="material-icons-round text-white" size="24"
                        >leaderboard</v-icon
                      >
                    </v-avatar>
                  </v-col>
                  <v-col sm="8" class="text-end">
                    <p
                      class="text-sm mb-0 text-capitalize text-body font-weight-light"
                    >
                      Beitrags Interaktionen {{ selectedYear || currentYear }}
                    </p>
                    <h4 class="text-h4 text-typo font-weight-bolder mb-0">
                      <span v-if="updatingEvents || loadingEventNews">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="2"
                          color="primary"
                        ></v-progress-circular>
                      </span>
                      <span v-else>{{ interactions }}</span>
                    </h4>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- <v-col sm="3" cols="12">
              <v-card class="mb-6 card-shadow border-radius-xl py-4">
                <v-row no-gutters class="px-4">
                  <v-col sm="4">
                    <v-avatar
                      color="bg-gradient-success border-radius-xl mt-n8"
                      class="shadow-success"
                      height="64"
                      width="64"
                    >
                      <v-icon class="material-icons-round text-white" size="24"
                        >store</v-icon
                      >
                    </v-avatar>
                  </v-col>
                  <v-col sm="8" class="text-end">
                    <p
                      class="
                        text-sm
                        mb-0
                        text-capitalize text-body
                        font-weight-light
                      "
                    >
                      Einnahmen
                    </p>
                    <h4 class="text-h4 text-typo font-weight-bolder mb-0">
                      34k
                    </h4>
                  </v-col>
                </v-row>
              </v-card>
            </v-col> -->

            <!-- <v-col sm="3" cols="12">
              <v-card class="mb-6 card-shadow border-radius-xl py-4">
                <v-row no-gutters class="px-4">
                  <v-col sm="4">
                    <v-avatar
                      color="bg-gradient-info border-radius-xl mt-n8"
                      class="shadow-info"
                      height="64"
                      width="64"
                    >
                      <v-icon class="material-icons-round text-white" size="24"
                        >comments</v-icon
                      >
                    </v-avatar>
                  </v-col>
                  <v-col sm="8" class="text-end">
                    <p
                      class="
                        text-sm
                        mb-0
                        text-capitalize text-body
                        font-weight-light
                      "
                    >
                      Kommentare
                    </p>
                    <h4 class="text-h4 text-typo font-weight-bolder mb-0">
                      91
                    </h4>
                  </v-col>
                </v-row>
                
              </v-card>
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
      <p
        class="mx-3 font-weight-normal text-body"
        style="font-size: 25px"
        v-if="events.length > 0"
      >
        Veranstaltungen {{ selectedYear || currentYear }}:
      </p>
      
      <!-- Keine Events Meldung -->
      <v-row v-if="events.length === 0 && !updating" class="mb-6 mt-10">
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl py-10 text-center">
            <div class="mx-auto mb-4">
              <v-avatar
                color="bg-gradient-secondary"
                size="80"
                class="shadow"
              >
                <i class="material-icons-round text-white" style="font-size: 40px;">event_busy</i>
              </v-avatar>
            </div>
            <h4 class="text-h5 text-typo font-weight-bolder mb-3">
              Keine Events gefunden
            </h4>
            <p class="text-body font-weight-light mb-4 px-6">
              Für das Jahr {{ selectedYear || currentYear }} sind keine Veranstaltungen vorhanden.
            </p>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mb-6 mt-10" v-else>
        <v-col
          v-for="(item, i) in events"
          :key="item.title + i"
          lg="4"
          class="pt-0 mb-10"
        >
          <v-card
            class="card card-shadow border-radius-xl py-5 text-center"
            @click="
              $router.push('/admin/events/details/' + item._id).catch(() => {})
            "
          >
            <div class="mt-n11 mx-4 card-header position-relative z-index-2">
              <div class="d-block blur-shadow-image" style="position: relative;">
                <img
                  v-if="item.img && !imageErrors[item._id]"
                  :src="getImage(item.img)"
                  class="img-fluid shadow border-radius-lg"
                  style="height: 200px; width: 100%; object-fit: cover;"
                  :alt="item.image"
                  @error="handleImageError(item._id)"
                />
                <div
                  v-else
                  class="d-flex align-items-center justify-content-center border-radius-lg shadow"
                  style="
                    height: 200px;
                    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
                  "
                >
                  <i class="material-icons-round text-white" style="font-size: 80px; opacity: 0.5;">
                    image_not_supported
                  </i>
                </div>
                <!-- Event Date Badge (left) -->
                <div
                  v-if="item.date"
                  class="position-absolute bottom-0 start-0 ma-3 px-3 py-2 border-radius-md"
                  style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(10px);"
                >
                  <div class="d-flex align-center">
                    <i class="material-icons-round text-white me-1" style="font-size: 18px;">event</i>
                    <span class="text-white text-sm font-weight-bold">
                      {{ formatEventDate(item.date) }}
                    </span>
                  </div>
                </div>
                <!-- Event Year Badge (right, only if not current year) -->
                <div
                  v-if="item.date && !isCurrentYear(item.date)"
                  class="position-absolute bottom-0 end-0 ma-3 px-3 py-2 border-radius-md"
                  style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(10px);"
                >
                  <div class="d-flex align-center">
                    <span class="text-white text-sm font-weight-bold">
                      {{ getEventYear(item.date) }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="item.img && !imageErrors[item._id]"
                class="colored-shadow"
                v-bind:style="{
                  backgroundImage: 'url(' + getImage(item.img) + ')',
                }"
              ></div>
            </div>

            <h5 class="font-weight-normal text-typo text-h5 mt-7 mb-2 px-4">
              {{ item.title }}
            </h5>
            <p class="mb-0 text-body font-weight-light px-5">
              {{ item.text }}
            </p>
            <hr class="horizontal dark my-6" />
            <div class="d-flex text-body mx-2 px-4">
              <p class="mb-0 font-weight-normal text-body">Anmeldungen:</p>
              <i
                class="material-icons-round position-relative ms-auto text-lg me-1 my-auto"
                >person</i
              >
              <p class="text-sm my-auto font-weight-light">
                {{ item.entries.length }}
              </p>
            </div>
            <div class="d-flex mb-4 mx-2 px-4 mt-4">
              <p class="mb-0 text-body font-weight-light">
                {{ item.active ? "Event aktiv" : "Event inaktiv" }}
              </p>
              <v-switch
                disabled
                :ripple="false"
                class="d-inline-flex mt-0 pt-0 switch ms-auto"
                v-model="item.active"
                hide-details
              ></v-switch>
            </div>
            <div class="d-flex mb-4 mx-2 px-4 mt-4">
              <p class="mb-0 text-body font-weight-light">
                {{
                  item.entries_active ? "Anmeldung aktiv" : "Anmeldung inaktiv"
                }}
              </p>
              <v-switch
                disabled
                :ripple="false"
                class="d-inline-flex mt-0 pt-0 switch ms-auto"
                v-model="item.entries_active"
                hide-details
              ></v-switch>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <p
        class="mx-3 font-weight-normal text-body"
        style="font-size: 25px"
        v-if="eventNews.length > 0"
      >
        News {{ selectedYear || currentYear }}:
      </p>
      <v-row class="mb-6 mt-10">
        <v-col
          v-for="(item, i) in eventNews"
          :key="item.title + i"
          lg="4"
          class="pt-0 mb-10"
        >
          <v-card
            class="card-shadow border-radius-xl py-5 text-center"
            @click="
              $router.push('/admin/news/details/' + item._id).catch(() => {})
            "
          >
            <div class="mt-n11 mx-4 card-header position-relative z-index-2">
              <div class="d-block blur-shadow-image">
                <img
                  v-if="item.img && !newsImageErrors[item._id]"
                  :src="getImage(item.img)"
                  class="img-fluid shadow border-radius-lg"
                  style="height: 200px; width: 100%; object-fit: cover;"
                  :alt="item.image"
                  @error="handleNewsImageError(item._id)"
                />
                <div
                  v-else
                  class="d-flex align-items-center justify-content-center border-radius-lg shadow"
                  style="
                    height: 200px;
                    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
                  "
                >
                  <i class="material-icons-round text-white" style="font-size: 80px; opacity: 0.5;">
                    image_not_supported
                  </i>
                </div>
              </div>
              <div
                v-if="item.img && !newsImageErrors[item._id]"
                class="colored-shadow"
                v-bind:style="{
                  backgroundImage: 'url(' + getImage(item.img) + ')',
                }"
              ></div>
            </div>
            <div class="d-flex mx-auto mt-n8">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="material-icons-round text-primary ms-auto px-5"
                    size="18"
                  >
                    refresh
                  </v-icon>
                </template>
                <span>Neu laden</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="material-icons-round text-info me-auto px-5"
                    size="18"
                  >
                    edit
                  </v-icon>
                </template>
                <span>Bearbeiten</span>
              </v-tooltip>
            </div>
            <h5 class="font-weight-normal text-typo text-h5 mt-7 mb-2 px-4">
              <a
                href="javascript:;"
                class="text-decoration-none text-default"
                >{{ item.title }}</a
              >
            </h5>
            <p class="mb-0 text-body font-weight-light px-5">
              {{ item.text }}
            </p>
            <hr class="horizontal dark my-6" />
            <div class="d-flex text-body mx-2 px-4">
              <p class="mb-0 font-weight-normal text-body">
                Beitragsinteraktionen:
              </p>
              <i
                class="material-icons-round position-relative ms-auto text-lg me-1 my-auto"
                >person</i
              >
              <p class="text-sm my-auto font-weight-light" v-if="item.views">
                {{ item.views }}
              </p>
              <p class="text-sm my-auto font-weight-light" v-else>0</p>
            </div>
            <div class="d-flex mb-4 mx-2 px-4 mt-4">
              <p class="mb-0 text-body font-weight-light">
                {{ item.active ? "Beitrag aktiv" : "Beitrag inaktiv" }}
              </p>
              <v-switch
                disabled
                :ripple="false"
                class="d-inline-flex mt-0 pt-0 switch ms-auto"
                v-model="item.active"
                hide-details
              ></v-switch>
            </div>
          </v-card>
        </v-col>
      </v-row>
      </div><!-- End: Dashboard Content -->
    </v-container>
  </div>
</template>

<script>
// import SalesCountry from "./Widgets/SalesCountry.vue";
import CardWebsiteViews from "./Widgets/CardWebsiteViews.vue";
import CardDailySales from "./Widgets/CardDailySales.vue";
import CalendarWidget from "./Widgets/CalendarWidget.vue";
// import CardCompletedTasks from "./Widgets/CardCompletedTasks.vue";
import PermissionDenied from "@/components/PermissionDenied.vue";
import permissionMixin from "@/mixins/permissionMixin";
import administrationData from "@/mixins/administrationMixin";
import YearSelector from "@/components/YearSelector.vue";

export default {
  name: "Dashboard",
  mixins: [permissionMixin, administrationData],
  components: {
    // SalesCountry,
    CardWebsiteViews,
    CardDailySales,
    CalendarWidget,
    // CardCompletedTasks,
    PermissionDenied,
    YearSelector,
  },
  data() {
    return {
      imageErrors: {},
      newsImageErrors: {},
      imageCards: [
        {
          image: require("@/assets/img/product-1-min.jpeg"),
          title: "Cozy 5 Stars Apartment",
          text: "The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to 'Naviglio' where you can enjoy the main night life in Barcelona.",
          price: "899",
          location: "Barcelona, Spain",
        },
        {
          image: require("@/assets/img/product-2-min.jpeg"),
          title: "Office Studio",
          text: "The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to 'Naviglio' where you can enjoy the main night life in Barcelona.",
          price: "1.119",
          location: "London, UK",
        },
        {
          image: require("@/assets/img/product-3-min.jpeg"),
          title: "Beautiful Castle",
          text: "The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to 'Naviglio' where you can enjoy the main night life in Barcelona.",
          price: "459",
          location: "Milan, Italy",
        },
      ],
    };
  },
  mounted() {
    // Initialize with current year
    const thisYear = new Date().getFullYear();
    if (!this.selectedYear) {
      this.$store.commit('selectedYear', thisYear);
    }
    
    // Load events, news and invoices with year filter
    // Use the year from store after commit
    const yearToUse = this.$store.getters.selectedYear || thisYear;
    console.log('📅 [DASHBOARD MOUNT] Loading with year:', yearToUse);
    this.$store.dispatch("getEventsAdmin", { year: yearToUse });
    this.$store.dispatch("getEventNewsAdmin", { year: yearToUse });
    this.$store.dispatch("getAllInvoices", { year: yearToUse });
  },
  computed: {
    // Analytics permission: Nur für Admins und Manager (KEIN POS)
    hasAnalyticsPermission() {
      // Admin im eigenen Kontext: volle Rechte
      const isAdminInOwnContext = this.isAdmin && !this.$store.getters.adminSimulated && 
                                   this.$store.getters.currentForManagerId === this.$store.getters.ownManagerId;
      
      // Manager mit canManage Berechtigung
      const hasManagerPermission = this.isManager;
      
      // POS-User AUSGESCHLOSSEN
      const result = isAdminInOwnContext || hasManagerPermission;
      console.log('🔍 [DASHBOARD] hasAnalyticsPermission:', result, { 
        isAdmin: this.isAdmin, 
        isManager: this.isManager,
        isPosUser: this.isPosUser,
        isAdminInOwnContext,
        hasManagerPermission
      });
      return result;
    },
    maxSlots() {
      var max = 0;
      if (this.newEvent.sponsors.length > 0) {
        this.newEvent.sponsors.forEach((sponsor) => {
          max += parseInt(sponsor.slots);
        });
      }
      return max;
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    darkMode() {
      return this.$store.getters.darkMode;
    },
    eventEntries() {
      var counter = 0;
      if (this.events) {
        this.events.forEach((event) => {
          if (event.entries) {
            counter += event.entries.length;
          }
        });
      }

      return counter;
    },
    contactFormSent() {
      return this.$store.getters.contactFormSent;
    },
    events() {
      return this.$store.getters.events;
    },
    eventNews() {
      return this.$store.getters.eventNews;
    },
    updatingEvents() {
      return this.$store.getters.updatingEvents;
    },
    loadingEventNews() {
      return this.$store.getters.loadingEventNews;
    },
    interactions() {
      var counter = 0;
      this.events.forEach((event) => {
        counter += event.views || 0;
      });
      this.eventNews.forEach((news) => {
        counter += news.views || 0;
      });
      return counter;
    },
    updating() {
      return this.$store.getters.updating;
    },
    authError() {
      return this.$store.getters.authError;
    },
    authMessage() {
      return this.$store.getters.authMessage;
    },
    emailResended() {
      return this.$store.getters.emailResended;
    },
  },
  methods: {
    getImage(link) {
      if (!link) return null;
      return process.env.VUE_APP_API_BASEURL + "/" + link;
    },
    handleImageError(itemId) {
      this.$set(this.imageErrors, itemId, true);
    },
    handleNewsImageError(itemId) {
      this.$set(this.newsImageErrors, itemId, true);
    },
    formatEventDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    isCurrentYear(dateString) {
      if (!dateString) return true;
      const date = new Date(dateString);
      const currentYear = new Date().getFullYear();
      return date.getFullYear() === currentYear;
    },
    getEventYear(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.getFullYear().toString();
    },
  },
  watch: {
    selectedYear() {
      // Reload events, news and invoices when year changes
      this.$store.dispatch("getEventsAdmin", { year: this.selectedYear || this.currentYear });
      this.$store.dispatch("getEventNewsAdmin", { year: this.selectedYear || this.currentYear });
      this.$store.dispatch("getAllInvoices", { year: this.selectedYear || this.currentYear });
    },
    events: {
      handler() {
        // Reset image errors when events change
        this.imageErrors = {};
      },
      deep: true,
    },
    eventNews: {
      handler() {
        // Reset image errors when news change
        this.newsImageErrors = {};
      },
      deep: true,
    },
  },
};
</script>
